import * as React from "react";
import classnames from "classnames";
import { usePrescriptionFormLayout } from "../../../../../../context/steps/PrescriptionFormStep/context/PrescriptionFormLayoutContext.js";
import { usePupillaryDistanceAlertLayout } from "../../../../../../hooks/steps/PrescriptionFormStep/hooks/use-pupillary-distance-alert-layout.js";
import "@grandvisionhq/configurator";
import "@grandvisionhq/state";
import "../../../../../../../../state/state/actions.js";
import "../../../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../../../state/bundles/state/bundles/reducer.js";
import "../../../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../../../state/products/state/products/selectors.js";
import "../../../../../../../../state/products/state/products/reducer.js";
/* empty css                            */
const PrescriptionFormLayout = ({
  components: { Column, Alert, PupillaryDistanceLink }
}) => {
  const shouldUseAlertLayout = usePupillaryDistanceAlertLayout();
  const { layout } = usePrescriptionFormLayout();
  if (shouldUseAlertLayout) {
    if (layout === "singleColumn") {
      return /* @__PURE__ */ React.createElement("div", { className: "prescription-form prescription-form--is-single-column" }, /* @__PURE__ */ React.createElement(Column, { side: "right", parametersType: "nonPupillaryDistance" }), /* @__PURE__ */ React.createElement("span", { className: "prescription-form__spacer" }), /* @__PURE__ */ React.createElement(Column, { side: "left", parametersType: "nonPupillaryDistance" }), /* @__PURE__ */ React.createElement(Alert, null), /* @__PURE__ */ React.createElement(Column, { side: "right", parametersType: "pupillaryDistance" }), /* @__PURE__ */ React.createElement(Column, { side: "left", parametersType: "pupillaryDistance" }), /* @__PURE__ */ React.createElement(PupillaryDistanceLink, null));
    } else {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classnames("prescription-form", {
            "prescription-form--is-hidden": layout === "unknown"
          })
        },
        /* @__PURE__ */ React.createElement(Column, { side: "right", parametersType: "nonPupillaryDistance" }),
        /* @__PURE__ */ React.createElement(Column, { side: "left", parametersType: "nonPupillaryDistance" }),
        /* @__PURE__ */ React.createElement(Alert, null),
        /* @__PURE__ */ React.createElement(Column, { side: "right", parametersType: "pupillaryDistance" }),
        /* @__PURE__ */ React.createElement(Column, { side: "left", parametersType: "pupillaryDistance" }),
        /* @__PURE__ */ React.createElement(PupillaryDistanceLink, null)
      );
    }
  }
  if (layout === "singleColumn") {
    return /* @__PURE__ */ React.createElement("div", { className: "prescription-form prescription-form--is-single-column" }, /* @__PURE__ */ React.createElement(Column, { side: "right", parametersType: "all" }), /* @__PURE__ */ React.createElement(PupillaryDistanceLink, null), /* @__PURE__ */ React.createElement("span", { className: "prescription-form__spacer" }), /* @__PURE__ */ React.createElement(Column, { side: "left", parametersType: "all" }), /* @__PURE__ */ React.createElement(PupillaryDistanceLink, null));
  } else {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames("prescription-form", {
          "prescription-form--is-hidden": layout === "unknown"
        })
      },
      /* @__PURE__ */ React.createElement(Column, { side: "right", parametersType: "all" }),
      /* @__PURE__ */ React.createElement(Column, { side: "left", parametersType: "all" }),
      /* @__PURE__ */ React.createElement(PupillaryDistanceLink, null)
    );
  }
};
export {
  PrescriptionFormLayout
};
//# sourceMappingURL=PrescriptionFormLayout.js.map
